import { HttpInterceptorFn } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from './notification.service';
import { inject } from '@angular/core';


export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const notification = inject(NotificationService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        error.status === 400 ||
        error.status === 403 ||
        error.status === 404 ||
        error.status === 500 ||
        error.status === 0 // 0 is often CORS or network error
      ) {
        // notification.show('An error occurred: ' + (error.message || 'Please try again later.'));
      }
      return throwError(() => error);
    })
  );
};